import { useCallback, useState } from 'react';

const d6 = () => 1 + Math.floor(Math.random() * 6);

/** One ability score by the 4d6 method: roll four dice and add the highest three. */
export const rollAbilityScore = (die = d6) => {
  const dice = [die(), die(), die(), die()];
  const dropped = Math.min(...dice);
  return { dice, dropped, total: dice.reduce((sum, value) => sum + value, 0) - dropped };
};
/** Six scores, highest first. */
export const rollAbilityScores = (die = d6) => Array.from({ length: 6 }, (_, id) => ({ id, ...rollAbilityScore(die) })).sort((a, b) => b.total - a.total);

/**
 * The creation wizard's rolled scores. Scores stay on the form as ordinary fields: a number here is placed only while its
 * score still holds it, so typing over a score hands its number back. Rolling again is unlimited and clears the numbers
 * placed from the last roll, leaving typed scores alone.
 */
export default function useAbilityRolls(form, updateForm, die) {
  const [rolls, setRolls] = useState([]);
  const [placements, setPlacements] = useState({});
  const [selectedId, setSelectedId] = useState(null);
  const placedStat = (roll) => Object.keys(placements).find((stat) => placements[stat] === roll.id && String(form?.[stat]) === String(roll.total)) || null;
  const rollFor = (stat) => rolls.find((roll) => placedStat(roll) === stat) || null;
  const selected = rolls.find((roll) => roll.id === selectedId && !placedStat(roll)) || null;
  const roll = useCallback(() => {
    const cleared = Object.fromEntries(Object.keys(placements).filter((stat) => rolls.some((entry) => entry.id === placements[stat] && String(form?.[stat]) === String(entry.total))).map((stat) => [stat, '']));
    if (Object.keys(cleared).length) updateForm(cleared);
    setPlacements({}); setSelectedId(null); setRolls(rollAbilityScores(die));
  }, [die, form, placements, rolls, updateForm]);
  const select = (id) => setSelectedId((current) => (current === id ? null : id));
  const place = (stat) => {
    if (!selected) return;
    updateForm({ [stat]: String(selected.total) });
    setPlacements((current) => ({ ...current, [stat]: selected.id }));
    setSelectedId(null);
  };
  const takeBack = (stat) => {
    updateForm({ [stat]: '' });
    setPlacements(({ [stat]: _removed, ...rest }) => rest);
  };
  return { rolls, selected, placedStat, rollFor, roll, select, place, takeBack };
}
